(function () {
  var modalId = 'whatsapp-contact-modal';
  var closeElsSelector = '[data-whatsapp-modal-close]';
  var lastActiveEl = null;

  var setHash = function (hash) {
    if (typeof hash !== 'string') return;
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;

    if (window.history && typeof window.history.pushState === 'function') {
      window.history.pushState(null, '', hash || window.location.pathname + window.location.search);
    } else {
      window.location.hash = hash || '';
    }
  };

  var clearHash = function () {
    if (window.history && typeof window.history.pushState === 'function') {
      window.history.pushState(null, '', window.location.pathname + window.location.search);
    } else {
      window.location.hash = '';
    }
  };

  var closest = function (el, selector) {
    if (!el) return null;
    if (el.closest) return el.closest(selector);
    while (el && el.nodeType === 1) {
      if (selector === 'a.whatsapp-button-link') {
        if (el.tagName === 'A' && el.classList && el.classList.contains('whatsapp-button-link')) return el;
      }
      if (selector === closeElsSelector) {
        if (el.getAttribute && el.getAttribute('data-whatsapp-modal-close') !== null) return el;
      }
      el = el.parentElement;
    }
    return null;
  };

  var ensureModal = function () {
    var existing = document.getElementById(modalId);
    if (existing) return existing;
    if (!document.body) return null;

    var modal = document.createElement('div');
    modal.id = modalId;
    modal.className = 'whatsapp-contact-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="whatsapp-contact-modal__backdrop" data-whatsapp-modal-close></div>' +
      '<div class="whatsapp-contact-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="whatsapp-contact-modal-text">' +
      '<button class="whatsapp-contact-modal__close" type="button" data-whatsapp-modal-close aria-label="Close">×</button>' +
      '<div id="whatsapp-contact-modal-text" class="whatsapp-contact-modal__text">' +
      '<span class="whatsapp-contact-modal__title">聯絡我們</span>' +
      '<span class="whatsapp-contact-modal__rest">Whatsapp : +852 63052351</span>' +
      '</div>' +
      '</div>';
    document.body.appendChild(modal);

    return modal;
  };

  var openModal = function (triggerEl) {
    var modal = ensureModal();
    if (!modal) return;
    lastActiveEl = triggerEl || document.activeElement;
    modal.setAttribute('aria-hidden', 'false');
    modal.setAttribute('data-open', 'true');
    var closeBtn = modal.querySelector(closeElsSelector);
    if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
  };

  var closeModal = function () {
    var modal = document.getElementById(modalId);
    if (!modal || modal.getAttribute('aria-hidden') === 'true') return;
    modal.setAttribute('aria-hidden', 'true');
    modal.removeAttribute('data-open');
    if (lastActiveEl && typeof lastActiveEl.focus === 'function') lastActiveEl.focus();
    lastActiveEl = null;
  };

  var syncStateFromHash = function () {
    var modal = ensureModal();
    if (!modal) return;
    var active = window.location.hash === '#' + modalId;
    if (active) {
      modal.setAttribute('aria-hidden', 'false');
      modal.setAttribute('data-open', 'true');
    } else {
      modal.setAttribute('aria-hidden', 'true');
      modal.removeAttribute('data-open');
    }
  };

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target ? closest(event.target, 'a.whatsapp-button-link') : null;
      if (link) {
        var href = link.getAttribute ? link.getAttribute('href') : '';
        if (href && href.indexOf('#' + modalId) !== -1) {
          event.preventDefault();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          lastActiveEl = link;
          setHash(modalId);
          syncStateFromHash();
          return;
        }
      }

      var closeEl = event.target ? closest(event.target, closeElsSelector) : null;
      if (closeEl) {
        event.preventDefault();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        clearHash();
        closeModal();
        syncStateFromHash();
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    var modal = document.getElementById(modalId);
    if (!modal || modal.getAttribute('data-open') !== 'true') return;
    if (event.key !== 'Escape') return;
    clearHash();
    closeModal();
    syncStateFromHash();
  });

  window.addEventListener('hashchange', syncStateFromHash);
  syncStateFromHash();
})();
